import { useQuery } from "@tanstack/react-query";

import { PostsReportReasons } from "../types/postsReportReasons.types";
import { getPostsReportReasons } from "../services/postsReportReasons.service";

export const usePostsReportReasons = () => {
  return useQuery<PostsReportReasons.Response>({
    queryKey: ["lists", "postsReportReasons"],
    queryFn: getPostsReportReasons,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
